export default __webpack_public_path__ + "static/media/volume-30.a2cf41ad.svg";